// extracted by mini-css-extract-plugin
module.exports = {"Portfolio":"Portfolio_Portfolio__2M16m","spindindust":"Portfolio_spindindust__1XHyK"};